import React, {memo, useCallback, useMemo, useState} from 'react';
import './index.scss';
import {getFormattedDate, getFormattedDayName, getFormattedTime} from '../../utils/format';
import {useInterval} from '../../hooks/interval';
import {useLocalization} from "../../hooks/localization";

export const DateTime = memo(function DateTime() {
    const [counter, setCounter] = useState(0);
    const {t} = useLocalization();

    useInterval(useCallback(() => setCounter(counter => counter + 1), []), 1000);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const dateTime = useMemo(() => new Date(), [counter]);
    const time = useMemo(() => getFormattedTime(dateTime), [dateTime]);
    const date = useMemo(() => getFormattedDate(dateTime), [dateTime]);
    const dayName = useMemo(() => getFormattedDayName(dateTime), [dateTime]);

    return (
        <div className="datetime">
            <span className="time">{time}</span>
            <div className="date">
                <span>{date}</span>
                <span>{t(dayName)}</span>
            </div>
        </div>
    );
});
